<div class="an-main">
    <div [ngClass]="showBanner ? 'display-banner': 'display-banner-none'"><an-banner></an-banner></div>

    <div class="sub-nav-container" *ngIf="subnavItems">
        <an-sub-nav 
            [subNavItems]="subnavItems"
            (onSelectItem)="onSelectItem($event)">
        </an-sub-nav>
    </div>

    <div class="vehicle-counts" *ngIf="vehicleCounts.length > 0">
        <ng-container *ngFor="let item of vehicleCounts; let last = last">
            <span class="vehicle-counts__item" *ngIf="item.value > 0" [ngClass]="{'available-item': item.label === 'Available'}"> 
                {{ item.value }} {{ item.label }}<span *ngIf="!last">, </span>
            </span>
        </ng-container>
    </div>

    <an-fav-tile-result class="an-fav-tile-result"></an-fav-tile-result>
</div>